import { API_BASE_URL } from "../../constants"
import axios from "../axios"

export default function getPortalSession() {
  return axios
    .get(`${API_BASE_URL}/stripe/get-portal-session`)
    .then((response) => response.data)
}
